/**
 * フィーチャーフラグ定義
 *
 * 環境（VITE_APP_ENV）に応じて機能の有効/無効を切り替えます。
 * UI 単位で表示制御したい場合は `components/FeatureFlag` を併用してください。
 */

type Environment = "sb" | "test" | "dev" | "alpha" | "stg" | "prd";

const currentEnv = import.meta.env.VITE_APP_ENV as Environment | undefined;

/**
 * オンボーディングガイド機能（ログイン前カルーセル + 初回ガイドツアー）が
 * 有効かどうか。
 *
 * v0.39.0より正式リリース。主要環境（dev/stg/prd）で有効。
 */
export const isOnboardingGuideEnabled = ["dev", "stg", "prd"].includes(currentEnv || "dev");
